'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from 'next/image';

import type { CartItemType } from '@eliadmin/core/src/api/cart/cart-types';

import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Paragraph } from '../../ui/paragraph';
import { Heading } from '../../ui/heading';
import { formatPrice, roundPrice } from '@eliadmin/core/src/utils/price-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function SummaryCardItem({ item }: { item: CartItemType }) {
  const { t } = useTranslations();
  const currency = useGlobalStore(s => s.generalLayout.currency);
  const currencySettings = useGlobalStore(s => s.generalLayout.currency_settings);

  return (
    <div className="flex w-full items-center justify-start gap-4">
      <div className="relative max-h-[90px] min-h-[90px] min-w-[90px] max-w-[90px] rounded-[4px] border border-border bg-[#F4F4F4] object-contain p-2 sm:max-h-[130px] sm:min-h-[130px] sm:min-w-[130px] sm:max-w-[130px] lg:p-3">
        <Image
          src={item?.image?.url ?? '/images/placeholder.png'}
          alt={resolveImageAlt(item?.image, item?.name)}
          fill
          className="absolute inset-0 h-full w-full object-contain object-center"
        />
      </div>

      <div className="flex w-full flex-col items-start justify-start gap-2">
        <div className="flex w-full flex-col items-start justify-start gap-1">
          <Heading tag="h6" title={item.name} className={{ title: 'tracking-tight' }} />
          <Paragraph size="base" color="muted-foreground">
            {t('text228')}&nbsp;<strong className="font-bold">{item.code}</strong>
          </Paragraph>
        </div>
        <div className="flex w-full items-center justify-between">
          <p className={cn('h6', 'font-semibold tracking-tighter text-black')}>
            {item.qty} x {formatPrice(roundPrice(item.price), currency, currencySettings)}
          </p>
        </div>
      </div>
    </div>
  );
}
